const CARDS = [
  {
    id: 1,
    img: '/assets/images/rick.jpeg',
    name: 'Rick Sanchez',
    species: 'Human',
    status: 'Alive',
    gender: 'Male',
    location: 'Citadel of Ricks',
  },
  {
    id: 2,
    img: '/assets/images/morty.jpeg',
    name: 'Morty Smith',
    species: 'Human',
    status: 'Alive',
    gender: 'Male',
    location: 'Citadel of Ricks',
  },
  {
    id: 3,
    img: '/assets/images/summer.jpeg',
    name: 'Summer Smith',
    species: 'Human',
    status: 'Alive',
    gender: 'Female',
    location: 'Earth (Replacement Dimension)',
  },
  {
    id: 4,
    img: '/assets/images/beth.jpeg',
    name: 'Beth Smith',
    species: 'Human',
    status: 'Alive',
    gender: 'Female',
    location: 'Earth (Replacement Dimension)',
  },
  {
    id: 5,
    img: '/assets/images/jerry.jpeg',
    name: 'Jerry Smith',
    species: 'Human',
    status: 'Alive',
    gender: 'Male',
    location: 'Earth (Replacement Dimension)',
  },
  {
    id: 6,
    img: '/assets/images/albert.jpeg',
    name: 'Albert Einstein',
    species: 'Human',
    status: 'Dead',
    gender: 'Male',
    location: 'Earth (C-137)',
  },
  {
    id: 7,
    img: '/assets/images/alien-morty.jpeg',
    name: 'Alien Morty',
    species: 'Alien',
    status: 'Unknown',
    gender: 'Male',
    location: 'Citadel of Ricks',
  },
  {
    id: 8,
    img: '/assets/images/alien-rick.jpeg',
    name: 'Alien Rick',
    species: 'Alien',
    status: 'Unknown',
    gender: 'Male',
    location: 'Citadel of Ricks',
  },
];

export default CARDS;
